import 'core-js/modules/es.object.assign.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { ThemeProvider, theme } from '@hub-la/design-system';
import { CssBaseline } from '@mui/material';
import { I18nextProvider } from 'react-i18next';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ContainerProvider } from './hooks/use-container.js';
import i18n from './i18n.js';

const AccountDropdownProvider = ({
  children,
  container,
  inverted: _inverted = false
}) => {
  const queryClient = new QueryClient();
  return jsx(ContainerProvider, Object.assign({
    container: container
  }, {
    children: jsxs(ThemeProvider, Object.assign({
      theme: _inverted ? theme.dark : theme.light
    }, {
      children: [jsx(CssBaseline, {}), jsx(I18nextProvider, Object.assign({
        i18n: i18n
      }, {
        children: jsx(QueryClientProvider, Object.assign({
          client: queryClient
        }, {
          children: children
        }))
      }))]
    }))
  }));
};

export { AccountDropdownProvider };
